﻿import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';

import configureStore from './Store';
import InitEpiMessages from '../Shared/Scripts/Utilities/EpiMessages';
import { updateLanguage } from '../Shared/Scripts/Store/EpiContext/Actions';
import { epiResolveLanguage } from '../Shared/Scripts/Utilities/EpiResolveLanguage';
import { AppContainerId } from './Models/Ids';

import { getSatser } from './Utilities/UtstyrsstipendSatserApi';
import { setSatser } from '../Shared/Scripts/Store/Satser/Actions';
import { setVisning } from './Store/Resultat/Actions';

const store = configureStore();
store.dispatch(updateLanguage(epiResolveLanguage()));
const container = document.getElementById(AppContainerId);

if (container != null) {
    const root = createRoot(container!);
    const contentLink = container.attributes['data-content'].value as string;
    InitEpiMessages(store, contentLink);

    getSatser()
        .then((data): void => {
            store.dispatch(setSatser(data));
        })
        .catch((): void => {
            store.dispatch(setVisning({ visGenerellFeil: true }));
        });

    const AppRoot = () => (
        <Provider store={store}>
            <App />
        </Provider>
    );

    root.render(<AppRoot />);
}
